module.exports = __webpack_public_path__ + "static/img/213.5f10ac2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/213.png
// module id = 9DyJ
// module chunks = 1